import styled from "styled-components";
import React, { useState, useEffect } from "react";
import Image27 from "../../assets/images/image27.png";
import Maps from "../../assets/images/image28.png";
import { Card, Row, Col, Button } from "react-bootstrap";
import { Map, Pin, Phone, Printer, Mail } from "@icons";
import { ContactAPI } from "../../common/api";
import { FooterSection, LeadingTitle } from "@components";
import "./ContactUs.scss";
import { useTranslation } from "react-i18next";
import { ShortDescriptionAPI } from "@api";

const ContactUsContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

function ContactUs() {
  const {t} = useTranslation();
  const [shortDesc, setShortDesc] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: "hub_investor" });
      setShortDesc(data.data);
    };

    if (!shortDesc) {
      loadData();
    }
  })
  return (
    <ContactUsContainer>
      <LeadingTitle
        title={t("kontak_hubungan_investor")}
        subtitle={shortDesc !== null ? shortDesc[0].description : ""}        
      />
      <Body />
      <FooterSection currentPage={t("kontak_hubungan_investor")}/>
    </ContactUsContainer>
  );
}

const Body = function () {
  const {t} = useTranslation();
  const [contactUs, setContactUs] = useState(null);
  useEffect(() => {
    const loadContact = async () => {
      const { data } = await ContactAPI();
      setContactUs(data.data.result);
    };

    if (contactUs === null) {
      loadContact();
    }
  });
  return (
    <div className="contact-us-page">
      <div className="position-relative d-none d-sm-block">
        <img className="w-100" src={Maps} alt="" />
        <Card
          className="p-3 shadow mb-5 mx-2 my-2 bg-white rounded position-absolute top-0 start-0"
          style={{ width: "min-content" }}
        >
          <img src={Image27} width="300px" alt="" />
          <Row>
            <Col xs={12} className="py-2 pt-4">
              <Row>
                <Col xs={1}>
                  <Pin fill="#000" />
                </Col>
                <Col xs={11} className="font-medium">
                  {contactUs != null ? contactUs[0].address : ""}
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="py-2">
              <Button
                variant="outline-warning"
                className="w-100"
                onClick={() =>
                  window.open(
                    `${contactUs != null ? contactUs[0].map_url : ""}`
                  )
                }
              >
                <Map fill="#F2A900" /> {t("buka_di_google_maps")}
              </Button>
            </Col>
            <Col xs={12} className="py-2">
              <Row>
                <Col xs={1}>
                  <Phone fill="#000" />
                </Col>
                <Col className="font-medium" xs={11}>
                  {contactUs != null ? contactUs[0].phone : ""}
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="py-2">
              <Row>
                <Col xs={1}>
                  <Printer fill="#000" />
                </Col>
                <Col className="font-medium" xs={11}>
                  {contactUs != null ? contactUs[0].fax : ""}
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="py-2">
              <Row>
                <Col xs={1}>
                  <Mail fill="#000" />
                </Col>
                <Col className="font-medium" xs={11}>
                  {contactUs != null ? contactUs[0].email : ""}
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </div>

      <div className="d-block d-sm-none">
        <Card className="p-3 shadow mb-5 bg-white rounded">
          <img src={Image27} width="100%" alt="" />
          <Row>
            <Col xs={12} className="py-2 pt-4">
              <Row>
                <Col xs={2}>
                  <Pin fill="#000" />
                </Col>
                <Col xs={10} className="font-medium ps-0">
                  {contactUs != null ? contactUs[0].address : ""}
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="py-2">
              <Button
                variant="outline-warning"
                className="w-100"
                onClick={() =>
                  window.open(
                    `${contactUs != null ? contactUs[0].map_url : ""}`
                  )
                }
              >
                <Map fill="#F2A900" /> {t("buka_di_google_maps")}
              </Button>
            </Col>
            <Col xs={12} className="py-2">
              <Row>
                <Col xs={2}>
                  <Phone fill="#000" />
                </Col>
                <Col className="font-medium ps-0" xs={10}>
                  {contactUs != null ? contactUs[0].phone : ""}
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="py-2">
              <Row>
                <Col xs={2}>
                  <Printer fill="#000" />
                </Col>
                <Col className="font-medium ps-0" xs={10}>
                  {contactUs != null ? contactUs[0].fax : ""}
                </Col>
              </Row>
            </Col>
            <Col xs={12} className="py-2">
              <Row>
                <Col xs={2}>
                  <Mail fill="#000" />
                </Col>
                <Col className="font-medium ps-0" xs={10}>
                  {contactUs != null ? contactUs[0].email : ""}
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default ContactUs;
